import * as React from 'react';
import { useDeviceType } from '../../../../responsive';
import { ETooltipViewType } from '../../types';
export function useTooltipViewType(_ref) {
  let {
    open,
    onClose
  } = _ref;
  const deviceType = useDeviceType();
  const [viewType, setViewType] = React.useState(getViewType(deviceType));

  /**
   * getDerivedStateFromProps
   *
   * https://ru.reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
   */
  const nextViewType = getViewType(deviceType);
  if (viewType !== nextViewType) {
    if (open) {
      onClose();
    }
    setViewType(nextViewType);
  }
  return viewType;
}
function getViewType(deviceType) {
  if (deviceType === 'phone') {
    return ETooltipViewType.Modal;
  }
  return ETooltipViewType.Popper;
}